'use client';

import React, { useContext, useMemo } from 'react';
import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { Heading4, Title2 } from 'components/Typography';
import { useTranslation } from 'react-i18next';
import { DashboardGenaralDetails } from 'components/Dashboard/DashboardGenaralDetails';
import { DashboardCategory } from 'components/Dashboard/DashboardCategory';
import { AuthContext } from 'structure/providers/AuthProvider';
import { dashboardInfoResponse } from 'utils/constants/dashboard-response.const';

export default function Dashboard() {
  const { t } = useTranslation('dashboard');
  const { dashboardInfo } = useContext(AuthContext);
  const { quests } = dashboardInfoResponse;

  const categories = useMemo(() => {
    return (quests ?? []).reduce(
      (acc, quest) => {
        if (!acc[quest.category]) {
          acc[quest.category] = [];
        }
        acc[quest.category].push(quest);
        return acc;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      {} as Record<string, any[]>
    );
  }, [quests]);

  return (
    <BaseLayout>
      <div className='flex flex-col items-center pb-9 lg:pb-12'>
        <Title2 className='pb-2 text-xl text-white md:text-[52px] md:leading-tight lg:pb-3'>
          {t('DASHBOARD')}
        </Title2>
        <Heading4 className='text-center font-light text-white'>
          {t('DASHBOARD_SUBTITLE')}!
        </Heading4>
      </div>
      <DashboardGenaralDetails dashboardResponse={dashboardInfo} />
      {Object.entries(categories)?.map(([category, items], index) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const quests = items as any[];
        return (
          <DashboardCategory key={index} quests={quests} title={category} />
        );
      })}
    </BaseLayout>
  );
}
